import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TransactionEffects } from './transaction.effects';
import { reducer } from './transaction.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('transaction', reducer),
    EffectsModule.forFeature([TransactionEffects]),
  ],
  providers: [TransactionEffects],
})
export class TransactionStoreModule {}
